/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ networkName: NonNullable<unknown> }} Page_Title_Embed_MapInputs */

const fr_page_title_embed_map = /** @type {(inputs: Page_Title_Embed_MapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carte du réseau ${i?.networkName}`)
};

const en_page_title_embed_map = /** @type {(inputs: Page_Title_Embed_MapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.networkName} network map`)
};

/**
* | output |
* | --- |
* | "{networkName} network map" |
*
* @param {Page_Title_Embed_MapInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_embed_map = /** @type {((inputs: Page_Title_Embed_MapInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Embed_MapInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_title_embed_map(inputs)
	return en_page_title_embed_map(inputs)
});